import React from 'react';
/* eslint-disable */
export function BellGradient(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M17.7295 24.5C17.4521 25.1072 17.0539 25.6113 16.5748 25.9617C16.0956 26.312 15.5524 26.4965 14.9995 26.4965C14.4466 26.4965 13.9034 26.312 13.4243 25.9617C12.9452 25.6113 12.547 25.1072 12.2695 24.5M21.6667 11.3C21.6667 9.49653 20.9643 7.76692 19.714 6.49167C18.4638 5.21643 16.7681 4.5 15 4.5C13.2319 4.5 11.5362 5.21643 10.286 6.49167C9.03571 7.76692 8.33333 9.49653 8.33333 11.3C8.33333 19.2333 5 21.5 5 21.5H25C25 21.5 21.6667 19.2333 21.6667 11.3Z"
        stroke="url(#paint0_linear_458_3283)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_458_3283"
          x1="15"
          y1="26.4965"
          x2="15"
          y2="4.5"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#FF512F" />
          <stop offset="1" stopColor="#DD2476" />
        </linearGradient>
      </defs>
    </svg>
  );
}
